import { ReportDefinitionSearchParams } from "types/search/form";

export const REPORT_LANGUAGES = ['en', 'fr', 'it', 'es'] as const;
export const REPORT_CURRENCIES = ['EUR', 'USD', 'JPY', 'CNY', 'GBP', 'AUD'] as const;
export const MAX_FEED_DOCUMENTS = 20000 as const;

export const REPORT_PERIODS = ['monthly', 'quarterly'] as const;
export const PLACEMENTS_COUNT = [10, 50, 200, 500] as const;
export const PERIOD_MINIMUM_DATE = '2020-03-01';

export const REPORT_SETTINGS_TYPES = ['coverage', 'periodic', 'campaign', 'excel'] as const;
export const REPORT_COMPARE_PERIODS_MODES: ComparePeriodsMode[] = ['previous', 'same_previous_year'];

export type ReportSettingsTypes = typeof REPORT_SETTINGS_TYPES[number];
export type FeedClippingSort = "reach" | "echo" | "miv" | "publication_date";
export type FeedClippingCount = typeof PLACEMENTS_COUNT[number];

export type ReportFeedClipping = { id: string, count: FeedClippingCount, sort?: string};

export type ComparePeriodsMode = 'previous' | 'same_previous_year' | 'custom';

export type ReportDefinitionSettings = {
	type: ReportSettingsTypes
	period: typeof REPORT_PERIODS[number]
	language: typeof REPORT_LANGUAGES[number]
	currency: typeof REPORT_CURRENCIES[number]
	minDate: string | null
	maxDate: string | null
	groupedByCountry: boolean
	feedClippings: Array<Omit<ReportFeedClipping, 'sort'>>;
	comparePeriodsMode: ComparePeriodsMode;
}; 

export type ReportDefinition = {
	search: Partial<ReportDefinitionSearchParams>;
	settings: ReportDefinitionSettings;
};

export type ReportConfigurationType = 'online' | 'powerpoint' | 'excel' | '';

export type ReportConfigurationModel = {
	id: number | null;
	name: string | null;
	type: ReportConfigurationType;
	definition: ReportDefinition;
	tenant_id?: string;
	created_at?: string;
	updated_at?: string;
	inserted_at?: string;
};
